import { SET_LENDER_PROFILE } from './types';

const initialState = {};

export const lenderProfile = (state = initialState, action) => {
  switch (action.type) {
    case SET_LENDER_PROFILE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
